import { makeEroadStyles } from "../../../styles";

type StyleProps = {
  isBackCompat?: boolean;
};

const useStyles = makeEroadStyles(
  (theme) => ({
    root: ({ isBackCompat }: StyleProps) => ({
      display: "inline-block",
      marginBottom: theme.spacing(5),
      color: theme.colors.onsurfaceFont,
      ...theme.typography.sizes.xs,
      "&:hover": {
        color: theme.colors.onsurfaceTechnicalFont,
      },
      [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
        ...theme.typography.sizes.sm,
        ...(isBackCompat && {
          marginBottom: 0,
          "& > :first-child": {
            fontSize: "2rem",
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(3),
            lineHeight: 1.4,
          },
          "& > :not(:first-child)": {
            display: "none",
          },
        }),
      },
    }),
  }),
  { name: "PageBreadcrumb" }
);

export { useStyles };
